import React, { useCallback, useEffect } from "react";
import lineLogo from './logos/line.svg';
import naverLogo from './logos/naver.png';
import googleLogo from './logos/google.png';
import kakaoLogo from './logos/kakao.svg';
import appleLogo from './logos/apple.jpg';
import Card from "components/Card";
import { toast } from "react-toastify";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { memberClient } from "common/apis/member";
import { useMemberAuth } from "common/contexts/Auth/Member";
import { useTranslation } from "react-i18next";

const LOGIN_POPUP_OPTIONS = 'width=600, height=600, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no';

const LoginContainer = ({ onLoggedIn = () => { } }) => {
    const { t } = useTranslation();
    const { login } = useMemberAuth();

    useEffect(() => {
        window.addEventListener('message', handleLoginMessage);
        return () => {
            window.removeEventListener('message', handleLoginMessage);
        }
    }, []);

    const handleLoginMessage = useCallback((e: MessageEvent) => {
        console.log("[Login] message received", e.data);
        const { refreshToken, token } = e.data;
        if (_.isNil(refreshToken) || _.isNil(token)) {
            return false;
        }
        login();
        onLoggedIn();
        return true;
    }, [login]);

    const onLineLoginButtonClicked = async () => {
        console.log("[onLineLoginButtonClicked]");
        const ret = await memberClient.get(`/member/line/url`);
        const url = ret.data;
        console.log("[onLineLoginButtonClicked] url", url);
        const popupWindow = window.open(url, 'newWindow', LOGIN_POPUP_OPTIONS);
    }

    const onNaverLoginButtonClicked = async () => {
        const ret = await memberClient.get(`/member/naver/url`);
        const url = ret.data;
        console.log("[onNaverLoginButtonClicked] url", url);
        const popupWindow = window.open(url, 'newWindow', LOGIN_POPUP_OPTIONS);
    }

    const onGoogleLoginButtonClicked = async () => {
        const ret = await memberClient.get(`/member/google/url`);
        const url = ret.data;
        console.log("[onGoogleLoginButtonClicked] url", url);
        const popupWindow = window.open(url, 'newWindow', LOGIN_POPUP_OPTIONS);
    }

    const onKakaoLoginButtonClicked = async () => {
        const ret = await memberClient.get(`/member/kakao/url`);
        const url = ret.data;
        console.log("[onKakaoLoginButtonClicked] url", url);
        const popupWindow = window.open(url, 'newWindow', LOGIN_POPUP_OPTIONS);
    }

    const onAppleLoginButtonClicked = async () => {
        const ret = await memberClient.get(`/member/apple/url`);
        const url = ret.data;
        console.log("[onAppleLoginButtonClicked] url", url);
        const popupWindow = window.open(url, 'newWindow', LOGIN_POPUP_OPTIONS);
    }

    return (
        <div>
            <div className="p-2 flex flex-col">
                <Card>
                    <div className="p-3 flex justify-center cursor-pointer" onClick={onLineLoginButtonClicked}>
                        <img src={lineLogo} alt="line-logo" className="w-7 h-7 mr-2" />
                        <div className="self-center">
                            {`${t('라인으로 로그인')}`}
                        </div>
                    </div>
                </Card>
                {/* <Card>
                    <div className="p-3 flex justify-center cursor-pointer" onClick={onNaverLoginButtonClicked}>
                        <img src={naverLogo} alt="naver-logo" className="w-7 h-7 mr-2" />
                        <div className="self-center">
                            {"네이버 계정으로 로그인"}
                        </div>
                    </div>
                </Card> */}
                <Card>
                    <div className="p-3 flex justify-center cursor-pointer" onClick={onGoogleLoginButtonClicked}>
                        <img src={googleLogo} alt="google-logo" className="w-7 h-7 mr-2" />
                        <div className="self-center">
                            {`${t('구글로 로그인')}`}
                        </div>
                    </div>
                </Card>
                <Card>
                    <div className="p-3 flex justify-center cursor-pointer" onClick={onKakaoLoginButtonClicked}>
                        <img src={kakaoLogo} alt="kakao-logo" className="w-7 h-7 mr-2" />
                        <div className="self-center">
                            {`${t('카카오톡으로 로그인')}`}
                        </div>
                    </div>
                </Card>
                <Card>
                    <div className="p-3 flex justify-center cursor-pointer" onClick={onAppleLoginButtonClicked}>
                        <img src={appleLogo} alt="apple-logo" className="w-7 h-7 mr-2 rounded-[4px]" />
                        <div className="self-center">
                            {`${t('애플로 로그인')}`}
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default LoginContainer;